import { useSyncExternalStore } from "react";
import { storageKey } from "../config";
import { t } from "../locale";

// A local reminder preference, never evidence that an icon currently exists.
const key = storageKey("home-screen-reminder");
const changeEvent = "yestv:home-screen-reminder";
let memoryFallback = false;
function readAcknowledged() {
  try { return memoryFallback || localStorage.getItem(key) === "acknowledged"; }
  catch { return memoryFallback; }
}
function subscribe(listener: () => void) {
  const onStorage = (event: StorageEvent) => {
    if (event.key === key || event.key === null) { memoryFallback = false; listener(); }
  };
  addEventListener("storage", onStorage);
  addEventListener(changeEvent, listener);
  return () => {
    removeEventListener("storage", onStorage);
    removeEventListener(changeEvent, listener);
  };
}
export function useInstallAcknowledged() {
  return useSyncExternalStore(subscribe, readAcknowledged);
}
function acknowledge() {
  try { localStorage.setItem(key, "acknowledged"); memoryFallback = false; }
  catch { memoryFallback = true; }
  dispatchEvent(new Event(changeEvent));
}

export default function InstallReminder({ onClose }: { onClose: () => void }) {
  return <section className="install-reminder" aria-label={t("Avoid duplicate icons")}>
    <strong>{t("Already have a Yestv icon on your Home Screen?")}</strong>
    <p>{t("Return to your Home Screen and tap Yestv. There is no need to add another icon.")}</p>
    <p>{t("If the icon is missing or was deleted, follow the steps below to add it again.")}</p>
    <button type="button" onClick={() => { acknowledge(); onClose(); }}>{t("I’ve already added it")}</button>
    <small>{t("We’ll stop suggesting it here. You can still choose Add again later.")}</small>
  </section>;
}
